/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-audit-summary.reducer';

export const PharmacyAuditSummary = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacyAuditSummaryList = useAppSelector(state => state.pharmacyAuditSummary.entities);
  const loading = useAppSelector(state => state.pharmacyAuditSummary.loading);
  const totalItems = useAppSelector(state => state.pharmacyAuditSummary.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-audit-summary-heading" data-cy="PharmacyAuditSummaryHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.home.title">Pharmacy Audit Summaries</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/pharmacy-audit-summary/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.home.createLabel">Create new Pharmacy Audit Summary</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacyAuditSummary.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacyAuditSummaryList && pharmacyAuditSummaryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.startDate">Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startDate')} />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.endDate">End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endDate')} />
                </th>
                <th className="hand" onClick={sort('discrepancyLoss')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.discrepancyLoss">Discrepancy Loss</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discrepancyLoss')} />
                </th>
                <th className="hand" onClick={sort('discrepancyGain')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.discrepancyGain">Discrepancy Gain</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discrepancyGain')} />
                </th>
                <th className="hand" onClick={sort('quantityLost')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.quantityLost">Quantity Lost</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('quantityLost')} />
                </th>
                <th className="hand" onClick={sort('quantityFound')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.quantityFound">Quantity Found</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('quantityFound')} />
                </th>
                <th className="hand" onClick={sort('auditStatus')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.auditStatus">Audit Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('auditStatus')} />
                </th>
                <th className="hand" onClick={sort('auditOutcome')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.auditOutcome">Audit Outcome</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('auditOutcome')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('newSync')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.newSync">New Sync</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('newSync')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.pharmacy">Pharmacy</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.lossBill">Loss Bill</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacyAuditSummaryList.map((pharmacyAuditSummary, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pharmacy-audit-summary/${pharmacyAuditSummary.id}`} color="link" size="sm">
                      {pharmacyAuditSummary.id}
                    </Button>
                  </td>
                  <td>{pharmacyAuditSummary.startDate}</td>
                  <td>{pharmacyAuditSummary.endDate}</td>
                  <td>{pharmacyAuditSummary.discrepancyLoss}</td>
                  <td>{pharmacyAuditSummary.discrepancyGain}</td>
                  <td>{pharmacyAuditSummary.quantityLost}</td>
                  <td>{pharmacyAuditSummary.quantityFound}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AuditStatus.${pharmacyAuditSummary.auditStatus}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AuditOutcome.${pharmacyAuditSummary.auditOutcome}`} />
                  </td>
                  <td>{pharmacyAuditSummary.active ? 'true' : 'false'}</td>
                  <td>{pharmacyAuditSummary.microSec}</td>
                  <td>{pharmacyAuditSummary.lastupdated}</td>
                  <td>{pharmacyAuditSummary.timestampentry}</td>
                  <td>{pharmacyAuditSummary.cursor}</td>
                  <td>{pharmacyAuditSummary.newSync ? 'true' : 'false'}</td>
                  <td>
                    {pharmacyAuditSummary.pharmacy ? (
                      <Link to={`/pharmacy/${pharmacyAuditSummary.pharmacy.id}`}>{pharmacyAuditSummary.pharmacy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyAuditSummary.lossBill ? (
                      <Link to={`/pharmacy-bill/${pharmacyAuditSummary.lossBill.id}`}>{pharmacyAuditSummary.lossBill.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pharmacy-audit-summary/${pharmacyAuditSummary.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-audit-summary/${pharmacyAuditSummary.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-audit-summary/${pharmacyAuditSummary.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.home.notFound">No Pharmacy Audit Summaries found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacyAuditSummaryList && pharmacyAuditSummaryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacyAuditSummary;
